import { render } from "./IconCheckmark.vue?vue&type=template&id=16037f36"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconCheckmark.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16037f36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16037f36', __exports__)) {
    api.reload('16037f36', __exports__)
  }
  
  module.hot.accept("./IconCheckmark.vue?vue&type=template&id=16037f36", () => {
    api.rerender('16037f36', render)
  })

}


export default __exports__